import { t } from 'i18next'
import NotificationType from '../../store/types/enums/NotificationType'
import { AutocompleteFetch } from '../Autocomplete/AutocompleteFetch'
import { SxProps } from '@mui/material'

type AutocompleteNotificationTypeProps = {
  notificationType: NotificationType
  notificationTypeChange: (option: NotificationType) => void
  sxProps?: SxProps
}

const AutocompleteNotificationType = ({
  notificationType,
  notificationTypeChange,
  sxProps,
}: AutocompleteNotificationTypeProps) => {
  const options = [NotificationType.EMAIL, NotificationType.PUSH, NotificationType.BOTH]

  return (
    <AutocompleteFetch<NotificationType>
      selectedItems={notificationType ? [notificationType] : []}
      setSelectedItems={items => {
        notificationTypeChange(items[0])
      }}
      options={options}
      getLabel={item => t(`components.settingsDialog.notificationTypes.${item}`) || ''}
      getId={item => item}
      labelTranslationKey="components.settingsDialog.notificationType"
      multiple={false}
      width="60%"
      sxProps={sxProps}
    />
  )
}

export default AutocompleteNotificationType
